import React from 'react';
import { About } from '../../about';
import { SEO, Banner } from '../../common';
import { Layout } from '../../layout';

export default function AboutUs() {
  return (
    <Layout>
      <SEO title="Quienes Somos" />
      <Banner />
      <About />
    </Layout>
  );
}
